module.exports = __webpack_public_path__ + "media/images/stock_groups/e202-a65047453b2c422bd08393a5660b5be2.svg";